exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes blinking{0%,to{opacity:0}50%{opacity:1}}@keyframes right-left{0%{left:70%}50%{left:-50%}to{left:100%}}story-line .story-line{position:relative;padding:10px;line-height:30px}story-line .story-line .continue{position:absolute;bottom:-40px;right:0;cursor:pointer;outline:none}story-line .story-line .continue:before{content:'';position:absolute;top:50%;left:-15px;transform:translateY(-50%);width:0;height:0;border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:8px solid #575d6b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/autoprefixer-loader?{browsers:['last 2 version']}!../~/sass-loader!./components/elements/storyLine/storyLine.scss
// module id = 39
// module chunks = 0